import React from 'react';

import { Row, Col } from 'antd';
import { SectionHeader, InfoBlock } from 'app/components/common';
import { CookieTable } from './cookieTable/CookieTable';

import { cookieHeaders, cookieTables } from './cookieData';

import './styles.less';

export const CookiePolicyPage = () => {
    return (
        <div className="page-cookie-policy">
            <SectionHeader>Cookie Policy</SectionHeader>

            <InfoBlock>
                <InfoBlock.Header animate id="why-cookies">
                    <span>Why we use cookies</span>
                </InfoBlock.Header>
                <InfoBlock.Body>
                    <Row>
                        <Col xs={ 24 } md={ 15 } className="info-section">
                            <p>Cookies are small files used to track some data on either your hard-drive or browser. These are widely used in order to help websites function as efficiently as possible. This site uses cookies that are strictly necessary in order to allow users to take courses effectively.</p>
                            <p>Below you will find more detailed information explaining the specific cookies we use and why we use them.</p>
                        </Col>
                        <Col xs={ 24 } md={ 9 } className="action-section">
                            { /* There are no actions available. */ }
                        </Col>
                    </Row>
                </InfoBlock.Body>
            </InfoBlock>

            <div className="cookie-types-section">
                {
                    cookieTables.map( ( table, index ) => (
                        <CookieTable
                            key={ `table-${ index }` }
                            title={ table.title }
                            headers={ cookieHeaders }
                            data={ table.data }
                        />
                    ) )
                }
            </div>
        </div>
    );
};
